import React from "react";

import Stack from "@mui/material/Stack";
import { useCanViewTestAnalytics } from "@src/components/LimitAccess/check-analytics-access";
import { AnalyticsAccessDenied } from "@src/features/analytics/AnalyticsAccessDenied";
import { SetDetails } from "@src/features/experiments/pages/priceExperience/components/SetDetails";
import { ConfigureCustomMetrics } from "@src/features/sharedExperience/components/configureAnalytics/ConfigureCustomMetrics";
import { ConfigureKeyMetrics } from "@src/features/sharedExperience/components/configureAnalytics/ConfigureKeyMetrics";
import { RemoveArchivedKeyMetricWarning } from "@src/features/sharedExperience/components/configureAnalytics/RemoveArchivedKeyMetricWarning";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";

export const ConfigureAnalytics = () => {
  const experience = useSelector(selectedExperience);
  const canViewTestAnalytics = useCanViewTestAnalytics();
  if (!canViewTestAnalytics) return <AnalyticsAccessDenied />;

  return (
    <Stack spacing={4}>
      {experience.category === "experiment" && <ConfigureKeyMetrics />}
      <ConfigureCustomMetrics />
      <SetDetails />
      <RemoveArchivedKeyMetricWarning />
    </Stack>
  );
};
